import {uuid} from 'external/lodash'
import {endOfDay} from 'external/date-fns'

const startDate = new Date()

const initialState = {
  attempted: false,  
  title: '',
  group: '',
  startDate,
  endDate: endOfDay(startDate),
  instructions: '',
  students: [],
  score: '',
  files: [],
  folderId: uuid(),
  disableEditGroups: false
}

export { initialState as default }
